export class Role {
  static ROLE_BACK_OFFICE = 'ROLE_BACK_OFFICE';
  static ROLE_DEALER = 'ROLE_DEALER';
  public title: string;
}
